// Phase II · Wave D.1 · LocaleRouteWrapper.
//
// Wraps the <App /> content with locale-aware behavior:
//   · Runs the pre-mount basename resolver (via getLocaleBasename())
//   · Syncs i18n.language with the URL on first mount
//   · Lazy-loads the common namespace for the active locale
//   · Reads the resolved locale from the module cache so re-renders
//     stay cheap
//
// The actual <BrowserRouter basename={...}> wiring happens in App.js
// (the single additive edit authorised by the brief). This component
// is responsible only for the i18n-side synchronisation.
import { useEffect } from "react";

import { getLocaleBasename } from "@/i18n/wave_d1/basename";
import { normaliseLocale } from "@/i18n/wave_d1/glms_locales";
import { glmsI18n, loadGlmsBundle } from "@/i18n/wave_d1/config";

export default function LocaleRouteWrapper({ children }) {
    useEffect(() => {
        try {
            const basename = getLocaleBasename();
            if (basename && basename.startsWith("/")) {
                const canonical = normaliseLocale(basename.slice(1));
                if (canonical && canonical !== glmsI18n.language) {
                    loadGlmsBundle(canonical, "common")
                        .finally(() => glmsI18n.changeLanguage(canonical));
                }
            }
        } catch (e) { /* no-op */ }
    }, []);
    return children;
}
